import { trimStart } from '../strings/utils.js';

const MatchStrict = 0;
const MatchDynamic = 1;
const MatchRestDynamic = 2;
const nextPart = (path) => {
	path = trimStart(path, "/");
	if (path === "") {
		return ["", ""];
	}
	const idx = path.indexOf("/");
	if (idx === -1) {
		return [path, ""];
	}
	return [path.slice(0, idx), path.slice(idx + 1)];
};
const parseDynamic = (key) => {
	if (key.length > 1) {
		const first = key[0];
		const last = key[key.length - 1];
		if (first === "{" && last === "}" || first === "[" && last === "]") {
			key = key.slice(1, key.length - 1);
			const result = parseDynamic(key);
			if (result.type === MatchStrict) {
				result.type = MatchDynamic;
			}
			return result;
		}
		if (first === ":") {
			return {
				key: key.slice(1),
				type: MatchDynamic
			};
		}
		if (first === "*") {
			return {
				key: key.slice(1),
				type: MatchRestDynamic
			};
		}
		if (key.startsWith("...")) {
			return {
				key: key.slice(3),
				type: MatchRestDynamic
			};
		}
		if (key.endsWith("...")) {
			return {
				key: key.slice(-3),
				type: MatchRestDynamic
			};
		}
	}
	return {
		key,
		type: MatchStrict
	};
};
const parseParams = (path, pattern) => {
	const params = {};
	let pathPart, patternPart;
	while (true) {
		[pathPart, path] = nextPart(path);
		[patternPart, pattern] = nextPart(pattern);
		if (patternPart === "" || pathPart === "") {
			break;
		}
		const info = parseDynamic(patternPart);
		switch (info.type) {
			case MatchDynamic:
				params[info.key] = pathPart;
				break;
			case MatchRestDynamic:
				params[info.key] = pathPart;
				if (path !== "") {
					params[info.key] += "/" + path;
				}
				return params;
		}
	}
	return params;
};
class Router {
	constructor() {
		this.pattern = "";
		this.part = "";
		this.match = MatchStrict;
		this.children = [];
	}
	insert(pattern) {
		this._insert(pattern, pattern);
		this.sort();
	}
	_insert(path, pattern) {
		if (path === "") {
			this.pattern = pattern;
			return;
		}
		const [part, remaining] = nextPart(path);
		let child = this.children.find((child) => child.part === part);
		if (!child) {
			child = new Router();
			child.part = part;
			child.match = parseDynamic(part).type;
			this.children.push(child);
		}
		child._insert(remaining, pattern);
	}
	params(path) {
		return parseParams(path, this.pattern);
	}
	search(path) {
		if (path === "") {
			if (this.pattern !== "") {
				return this;
			}
			return null;
		}
		const [part, remaining] = nextPart(path);
		for (const child of this.children) {
			switch (child.match) {
				case MatchStrict: {
					if (child.part === part) {
						const result = child.search(remaining);
						if (result) {
							return result;
						}
					}
					break;
				}
				case MatchDynamic: {
					const result = child.search(remaining);
					if (result) {
						return result;
					}
					break;
				}
				case MatchRestDynamic: return child;
			}
		}
		return null;
	}
	sort() {
		this.children.sort((a, b) => a.match - b.match);
		for (const child of this.children) {
			child.sort();
		}
	}
}

export { Router };
//# sourceMappingURL=trie.js.map
